module.exports = __webpack_public_path__ + "img/the-field-gal-4.d267b11b.jpg";